export default __webpack_public_path__ + "static/media/splitIconMobile.538e2630.svg";